<script>
import Paginator from "@/components/molecules/pagination/paginator";
export default {
  name: "ProductsPaginator",
  components: {
    Paginator
  },
  props: {
    /**
     * Current page number
     */
    current: {
      type: Number,
      default: 1
    },
    /**
     * Total number of pages
     */
    total: {
      type: Number,
      default: 5
    }
  },
  computed: {
    query() {
      return { ...this.$route.query };
    },
    path() {
      return this.$route.path + "?";
    }
  }
};
</script>

<template>
  <Paginator
    :current="current"
    :total="total"
    :query="query"
    :path="path"
    is-link
  />
</template>
